import React from 'react';
import styles from './styles';

// RW-3839: the top-bar 🔍 opens the one real search (/search). It used to
// expand a quick box that only matched loaded feed posts, their authors,
// events and documents — so a contact, listing, vendor or most colleagues
// came back "No results found", which reads as "it isn't in Rêve".
export default function SearchBar({ onOpen }) {
  return (
    <button
      type="button"
      style={styles.headerIconBtn}
      aria-label="Search everything"
      title="Search everything"
      onClick={() => onOpen && onOpen()}
    >
      <span style={{ fontSize: 16 }}>🔍</span>
    </button>
  );
}
